module.exports = __webpack_public_path__ + "static/hpaLogo-d3c74d7d6ae14562076a560c3a3a419d.png";